import '../../css/home/article_list.scss';

$(function() {

    if ($('.datetimepicker_from').length > 0) {
        $('.datetimepicker_from').datetimepicker({
            theme: 'dark',
            format: 'M d Y',
            timepicker: false,
        });
    }

    if ($('.datetimepicker_to').length > 0) {
        $('.datetimepicker_to').datetimepicker({
            theme: 'dark',
            format: 'M d Y',
            timepicker: false,
        });
    }

    if ($('.submit_btn').length > 0) {
        let domain = window.location;
        const hostname = domain.hostname;
        const protocol = domain.protocol;
        const pathname = domain.pathname;
        $('.submit_btn').click(function() {
            location.href = protocol + '//' + hostname + pathname +
                '?from=' + $('input[name=from]').val() +
                '&to=' + $('input[name=to]').val();
        });
    }

});